import React from 'react';
import PhoneInputComponent from './PhoneInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}
const TelephoneNumberInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <PhoneInputComponent question={question} />;
  }
};

export default TelephoneNumberInputPicker;
